var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-page-header',{staticStyle:{"border":"1px solid rgb(235, 237, 240)"},attrs:{"title":'User Account'},on:{"back":function () { return _vm.$router.go(-1); }}})}
var staticRenderFns = []

export { render, staticRenderFns }